module.exports = __webpack_public_path__ + "static/media/aggregated-measure-output-icon.00c712c5.svg";